import script from "./ModalErrorIntegrations.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalErrorIntegrations.vue?vue&type=script&setup=true&lang=ts"

import "./ModalErrorIntegrations.vue?vue&type=style&index=0&id=7ce04bfa&lang=scss"

const __exports__ = script;

export default __exports__